import { setChildMap } from './utils';
// Maps text sizes to pixel values
// If sizes differ by screen size, create a map for the screen size and its associated pixel value
var HeaderSize = new Map();
HeaderSize.set(1, 16);
HeaderSize.set(2, 20);
HeaderSize.set(3, 24);
HeaderSize.set(4, setChildMap('LARGE', 32).set('MEDIUM', 32).set('SMALL', 32));
HeaderSize.set(5, setChildMap('LARGE', 48).set('MEDIUM', 40).set('SMALL', 40));
HeaderSize.set(6, setChildMap('LARGE', 64).set('MEDIUM', 56).set('SMALL', 56));
// Getter for header size
export var getHeaderSize = function (_a) {
    var size = _a.size, screenSize = _a.screenSize;
    if (size >= 4 && !screenSize) {
        /* eslint-disable */
        console.error('screenSize is required with header sizes 4 - 6');
    }
    var value = HeaderSize.get(size);
    if (value && typeof value === 'object') {
        return value.get(screenSize);
    }
    return value;
};
export default {};
